export default __webpack_public_path__ + "static/media/caja-los-andes.6a9152f4.svg";